<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="500" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-6 Setup user
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.pa-6
      v-form(ref="form")
        div.text-sm.font-semibold.neutral500--text {{ $t('email') }}
        v-text-field.text-sm.mt-2.round-xl(v-model="email" :placeholder="$t('email')" outlined dense height="48" :rules="rules.email" hide-details="auto" :loading="isFetching" @keypress="clearVar" @keyup="inputChange")
        template(v-if="showNext === 'password'")
          div.text-sm.font-semibold.neutral500--text.mt-4 Password
          v-text-field.text-sm.mt-2.round-xl(v-model="password" placeholder="Password" outlined dense height="48" :rules="rules.password" :type="passwordType" hide-details="auto")
            template(#append)
              v-btn(icon small style="margin-top: 2px;" @click="changePasswordType(passwordType)")
                v-icon(color="neutral500") {{ passwordType === 'text' ? 'mdi-eye-off' : 'mdi-eye' }}
          div.text-sm.font-semibold.neutral500--text.mt-4 Confirm password
          v-text-field.text-sm.mt-2.round-xl(v-model="confirmPassword" placeholder="Confirm password" outlined dense height="48" :rules="rules.confirm_password" :type="passwordType" hide-details="auto")
            template(#append)
              v-btn(icon small style="margin-top: 2px;" @click="changePasswordType(passwordType)")
                v-icon(color="neutral500") {{ passwordType === 'text' ? 'mdi-eye-off' : 'mdi-eye' }}
        template(v-if="showNext === 'alert'")
          .text-sm.font-semibold.success600--text.text-center.mt-3 This email is already registered with Yezza. Please log in using the previous password
          
    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="closeDialog" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(color="primary" depressed @click="saveData" :loading="isLoading") {{ $t('save') }}
      

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'

export default {
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false
    },
    provider: {
      default: null
    }
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      email: null,
      showNext: null,
      password: null,
      confirmPassword: null,
      passwordType: 'text',
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required'],
        password: [(v) => (v != null && v.toString().trim().length) || 'This field is required', (v) => (v != null && v.length >= 8) || 'Password must be at least 8 characters long'],
        confirm_password: [v => !!v || 'This field is required', v => v === this.password || 'Passwords do not match'],
        email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
  },
  methods: {
    ...mapActions(['showMessage']),
    checkEmail () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isFetching = true
      this.$axios.get(`/users/check_email/?email=${this.email}`)
        .then(resp => {
          if (resp.data.available) {
            this.showNext = 'password'
          } else {
            this.showNext = 'alert'
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    changePasswordType (type) {
      if (type === 'text') {
        this.passwordType = 'password'
      } else {
        this.passwordType = 'text'
      }
    },
    inputChange: debounce(function () {
      this.checkEmail()
    }, 750),
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let data = {
        email: this.email
      }
      if (this.password) {
        data.password = this.password
      }
      this.$axios.post(`/clinics/${this.company.slug}/providers/${this.provider}/signup`, data)
        .then(() => {
          this.showMessage(['success', 'Setup user successful'])
          this.$emit('reset')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clearVar () {
      this.showNext = null
      this.password = null
      this.confirmPassword = null
    },
    closeDialog () {
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>